// extracted by mini-css-extract-plugin
export default {"root":"MH0g51"};